import domtoimage from 'dom-to-image'

const scale = 2

export const getBlob = (domNode: HTMLElement): Promise<Blob> =>
  domtoimage.toBlob(domNode, {
    cacheBust: true,
    height: domNode.clientHeight * scale,
    style: {
      transform: 'scale(' + scale + ')',
      transformOrigin: 'top left',
    },
    width: domNode.clientWidth * scale,
  })
